import React from 'react';

import DsExpiredLink from 'screens/DS/ExpiredLink';

const ExpiredLinkPage = () => {
  return <DsExpiredLink />;
};

export default ExpiredLinkPage;
